/**
 * 调用方式:
 * uppercase(str)  //小写转大写
 * lowercase(str)  //大写转小写
 *  @static
 *  @returns {str}
 * @memberof UtilService
 */
// 转换大写
import  JSEncrypt  from "jsencrypt";
import CryptoJS from 'crypto-js'
import moment from 'moment'   //时间处理
console.log('process.env',process.env);
var appServicePublic,aseKeyNew,appClientPrivate;
if(process.env.NODE_ENV == "development"){
  // 公钥
  appServicePublic = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnDVy6coJxMrSyra9YNUNHy47LxeS76tnoJkV3cXbno22YFaidccDcwtP9xCVRqcPnbFqtFB9D/lQEMN6keeexKi+/JvhakOsOQiXpeIn4wncIf3aQIk7nPeVOnVCJ/4xFioE6Rni3DwEUZAIqcSilXSfKnvDvBimX2Q0vY39QXSy92kXk3i8dLW2NaasbnLgG3HxqJ4vNnSduxGBeNrBF8pqL5VLpyZfARRuOqt4ioeDcjP9XXqpK4XroHoo4Vo9ayP8UHCTQnhmBMzo1iA1kupGG9oMxgAav6dizsE/1kdjdvITIYx8He0J0FB/FpPDqku1ZciW1YCVKMc/x3rEKQIDAQAB'
  // 随机数
  aseKeyNew = 'abcdef0123456789'
  // 私钥
  appClientPrivate = 'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCyW2sL+Nw2i9uGhcK12Es4Y9naF+z/tkd9niyXGUzy+7Zxk7xCEln9IvoeNKLwqd8A+CsKxQtS3pM4ffuYzFYtxsH/cYb5VpSc/FST6HxOIF0YNh25NckQTz1e532GoXovS8SR9QNqpUWPwoJtjDw64aGIzd1TGUl4O+2NrWej9ubm1oVcEeYBKexyo4Ucf2s5LNjTrSmkWbAkTob1AvjXaONF7RqFK/GWUMYmpCKhE53I8nfWD/w4puYEsEVaTTvim7FgdpQ5xb1emnlzm6TuRwDFM3R9pvwbHidoEGY/vbgapNmG6Fkqll3eUJgiZKTWY0WFpUl1kt33olde6mgZAgMBAAECggEBAIBNEuxB0OfMI9bZUf/N4A5ohcZFf89TKIpMxnbLVHdWax+4zqwY13MpPhOMecn16N2hqBTPOh4aznzM47g/BZ9YYyWGXTnv9mgXfCAKFaF91nocM7WP41tAJT2n+LxoXKS5NGZqglKtISURHxH+1zTkKndm39dvUVKUiYZpPyzKsU6o9xJxwTvqlposP5oZqiWbaF3KDMCaQO1K8MXsnJ2A9O80TCVjcRjH1AIwASr33QRJoYoQXjxoAqenkRDvfq5WCl6u81GixB1/dL7eo7zBTNSWMnUisAFcPHp3/D32D+06uAW1TydbgeYHJ9cQKozMSGGN7sYix3amqJhe56ECgYEA9cQKQ26+cHLScYZ+SN/zLGFTZ1g4VS5GdMW7HxyrGgk7GVsD0Yr4zIXRZktcH1bWY+PXGa1YSCDLZ+lbEnVABVNiuOfNAXhoqAtCjONzJwKGQ5EYDcgJMR3m2zjntBSK1HjzGpoLZuelTKvPg6N4HEo4JVc6dEQirgDh0esK/KMCgYEAucjGZ774NlyJgs2MGEaprPiS8u5Yfgq8pRuy0wKgOtieM6ct8ptTeS/8zp8Bnp7FPb0a0Jtkd9uG37iqVwkEnSLlxsrNiCcG3Ujl6/bKsBPHSkTnBB90fua72VUPHbKBkq62XZIg59qJoF8n/k6S3JRinZu5lxfi4rekVPoyOBMCgYEA6XF0Okc4F4HJiVIyJDCtQEuWOITgxXB2NjcXnd7SW6HHBDeisehqmYLGu377mz0V2b4ytE4mnCSicSqEekzrKePh0zdDUJE5/9zqMv9dgwFv3UA18+k9ae04OqWb2T7l/BqC+JK4H+AK8IAGVcjxrxWErVtkx8lsk5F87rNvNTcCgYA0KzfjfBGxGi0XCOcVDgqpYqfJBbrdseAlMPD3Jd6eh6Ns974ESS+YcSw5TRckVosmegqkl24P5hoqim1ywTqFcX46Y0pxuBvKWaUOrJ9f8D3fEhgY5UhONjZ7odH70dtmuB7Hibgpwwkwemf9lkzRGe3TOh5UWkXAyjagEh219wKBgEywf08buQqxuOr2mnCaimc8Qpp5LYLsS2SMYXvybBZqu6ZFBez1BZLuk116cbausZS5AQuAAe1TjG24A24KuDkB+uT2v1gmMnl/4hNLH45Pfu84F6bvZhEqDhGpcYWe2A2aPiqQKhtd3CjoQF1tosyRfWxBvOQeNu9w+HJpg9yN'

}else{
  // 公钥
   appServicePublic = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnDVy6coJxMrSyra9YNUNHy47LxeS76tnoJkV3cXbno22YFaidccDcwtP9xCVRqcPnbFqtFB9D/lQEMN6keeexKi+/JvhakOsOQiXpeIn4wncIf3aQIk7nPeVOnVCJ/4xFioE6Rni3DwEUZAIqcSilXSfKnvDvBimX2Q0vY39QXSy92kXk3i8dLW2NaasbnLgG3HxqJ4vNnSduxGBeNrBF8pqL5VLpyZfARRuOqt4ioeDcjP9XXqpK4XroHoo4Vo9ayP8UHCTQnhmBMzo1iA1kupGG9oMxgAav6dizsE/1kdjdvITIYx8He0J0FB/FpPDqku1ZciW1YCVKMc/x3rEKQIDAQAB'
  // 随机数
   aseKeyNew = 'abcdef0123456789'
  // 私钥
   appClientPrivate = 'MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCyW2sL+Nw2i9uGhcK12Es4Y9naF+z/tkd9niyXGUzy+7Zxk7xCEln9IvoeNKLwqd8A+CsKxQtS3pM4ffuYzFYtxsH/cYb5VpSc/FST6HxOIF0YNh25NckQTz1e532GoXovS8SR9QNqpUWPwoJtjDw64aGIzd1TGUl4O+2NrWej9ubm1oVcEeYBKexyo4Ucf2s5LNjTrSmkWbAkTob1AvjXaONF7RqFK/GWUMYmpCKhE53I8nfWD/w4puYEsEVaTTvim7FgdpQ5xb1emnlzm6TuRwDFM3R9pvwbHidoEGY/vbgapNmG6Fkqll3eUJgiZKTWY0WFpUl1kt33olde6mgZAgMBAAECggEBAIBNEuxB0OfMI9bZUf/N4A5ohcZFf89TKIpMxnbLVHdWax+4zqwY13MpPhOMecn16N2hqBTPOh4aznzM47g/BZ9YYyWGXTnv9mgXfCAKFaF91nocM7WP41tAJT2n+LxoXKS5NGZqglKtISURHxH+1zTkKndm39dvUVKUiYZpPyzKsU6o9xJxwTvqlposP5oZqiWbaF3KDMCaQO1K8MXsnJ2A9O80TCVjcRjH1AIwASr33QRJoYoQXjxoAqenkRDvfq5WCl6u81GixB1/dL7eo7zBTNSWMnUisAFcPHp3/D32D+06uAW1TydbgeYHJ9cQKozMSGGN7sYix3amqJhe56ECgYEA9cQKQ26+cHLScYZ+SN/zLGFTZ1g4VS5GdMW7HxyrGgk7GVsD0Yr4zIXRZktcH1bWY+PXGa1YSCDLZ+lbEnVABVNiuOfNAXhoqAtCjONzJwKGQ5EYDcgJMR3m2zjntBSK1HjzGpoLZuelTKvPg6N4HEo4JVc6dEQirgDh0esK/KMCgYEAucjGZ774NlyJgs2MGEaprPiS8u5Yfgq8pRuy0wKgOtieM6ct8ptTeS/8zp8Bnp7FPb0a0Jtkd9uG37iqVwkEnSLlxsrNiCcG3Ujl6/bKsBPHSkTnBB90fua72VUPHbKBkq62XZIg59qJoF8n/k6S3JRinZu5lxfi4rekVPoyOBMCgYEA6XF0Okc4F4HJiVIyJDCtQEuWOITgxXB2NjcXnd7SW6HHBDeisehqmYLGu377mz0V2b4ytE4mnCSicSqEekzrKePh0zdDUJE5/9zqMv9dgwFv3UA18+k9ae04OqWb2T7l/BqC+JK4H+AK8IAGVcjxrxWErVtkx8lsk5F87rNvNTcCgYA0KzfjfBGxGi0XCOcVDgqpYqfJBbrdseAlMPD3Jd6eh6Ns974ESS+YcSw5TRckVosmegqkl24P5hoqim1ywTqFcX46Y0pxuBvKWaUOrJ9f8D3fEhgY5UhONjZ7odH70dtmuB7Hibgpwwkwemf9lkzRGe3TOh5UWkXAyjagEh219wKBgEywf08buQqxuOr2mnCaimc8Qpp5LYLsS2SMYXvybBZqu6ZFBez1BZLuk116cbausZS5AQuAAe1TjG24A24KuDkB+uT2v1gmMnl/4hNLH45Pfu84F6bvZhEqDhGpcYWe2A2aPiqQKhtd3CjoQF1tosyRfWxBvOQeNu9w+HJpg9yN'

}

const Rxports = {
  uppercase(string) {
    return this.isString(string) ? string.toUpperCase() : string;
  },
  // 转换小写
  lowercase(string) {
    return this.isString(string) ? string.toLowerCase() : string;
  },
  /**
   * @description:jsonp url拼接参数
   * @param
   * @returns {*}
   */
  paramJsonp(data) {
    let url = "";

    for (var k in data) {
      let value = data[k] !== undefined ? data[k] : "";

      url += "&" + k + "=" + encodeURIComponent(value);
    }
    return url ? url.substring(1) : "";
  },
  /**
   * 是否字符串
   * @static
   * @param {*} value
   * @returns {boolean}
   *
   * @memberof UtilService
   */
  isString(value) {
    return typeof value === "string";
  },
  // 获取时间戳
  getTimeTtamp(){
    return (new Date().getTime())
  },
  //RSA加密
  encryptRSA() {
    var jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(appServicePublic);
    return jsencrypt.encrypt(aseKeyNew);
  },
  //RSA解密
  decryptRSA(key) {
    var decrypt = new JSEncrypt();
    decrypt.setPrivateKey(appClientPrivate);
    return decrypt.decrypt(key);
  },
  //AES加密
  encryptAES(data) {
    //var data = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
    //    mode: CryptoJS.mode.ECB,
    //    padding: CryptoJS.pad.Pkcs7
    //  }).toString();
    // return data;
    var key = CryptoJS.enc.Utf8.parse(aseKeyNew); //将秘钥转换成Utf8字节数组

    //加密
    var encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
      //iv: CryptoJS.enc.Utf8.parse(aseKey.substr(0,16)),
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    var data = encrypt.toString(); //加密后的数据
    return data;
  },
  //AES解密
  decryptAES(data, key) {
    var data = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
    return data;
  }
};
export default Rxports;



// WEBPACK FOOTER //
// ./src/js/service/common.js